module.exports = __webpack_public_path__ + "static/media/w6-t.e852722d.jpg";